var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('h3',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.weeklyTitle))]),_c('el-divider'),_c('PeriodicalBox',{attrs:{"title":"NEJM","list":_vm.nejmList,"has-more":false},on:{"more":function($event){return _vm.onMoreClick('nejm')},"item-click":_vm.onItemClick}}),_c('a-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }